module.exports = __webpack_public_path__ + "static/media/page-not-found.ea2c9921.svg";